import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from './config/authConfig'
import reportWebVitals from './reportWebVitals'

import { store } from './store'

const App = React.lazy(() => import(/* webpackChunkName: "App" */ './App'))

const msalInstance = new PublicClientApplication(msalConfig)

const Main = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <Suspense fallback={<div className="loading" />}>
          <App />
        </Suspense>
      </Provider>
    </MsalProvider>
  )
}

ReactDOM.render(<Main />, document.getElementById('root'))

reportWebVitals()
